import React from 'react';
import PageSection from '../../components/page-section/PageSection';
import ArticleMarkdown from '../../components/article-markdown/ArticleMarkdown';
import AgentList, { AgentListProps } from '../../components/agent-list/AgentList';
import Markdown from '../../components/markdown/Markdown';

export interface TeamSectionProps {
  title?: string,
  content?: string,
  agents: AgentListProps['agents'],
  backgroundGradient?: string,
}

export const TeamSection: React.FC<TeamSectionProps> = ({
  title,
  content,
  agents,
  backgroundGradient,
}) => (
  <PageSection backgroundGradient={backgroundGradient}>
    <PageSection.Wrapper>
      {title && (
        <PageSection.Title>
          <Markdown>
            {title.trim()}
          </Markdown>
        </PageSection.Title>
      )}
      {content && (
        <PageSection.Block>
          <ArticleMarkdown>
            {content}
          </ArticleMarkdown>
        </PageSection.Block>
      )}
      <PageSection.Block>
        <AgentList agents={agents} />
      </PageSection.Block>
    </PageSection.Wrapper>
  </PageSection>
);

export default TeamSection;
